import Cookies from 'js-cookie';

const initCartReminder = () => {
	const cartreminder = document.querySelector( '.mdl_cartreminder' );

	if ( cartreminder ) {
		window.addEventListener( 'showcartreminder.acl', () => {

			const cookieVal = Cookies.get( 'closedcartreminder' );
			if ( typeof cookieVal === 'undefined' ) {
				cartreminder.classList.add( 'en_is_active' );
			}
		} );

		document.addEventListener( 'click', ( ev ) => {
			if ( ev.target && ev.target.matches( '.en_js_close_cartreminder' ) ) {
				ev.preventDefault();
				close();
			}
		} );

		const close = ( notsetcookie = false ) => {
			cartreminder.classList.remove( 'en_is_active' );
			if ( !notsetcookie ) {
				Cookies.set( 'closedcartreminder', 'true', {expires: 1, path: '/'} );
			}
		}
	}
};

export { initCartReminder };
